// SPDX-License-Identifier: AGPL-3.0-or-later

import {modal, pushWithKey} from '@app/features/ui/commands/ModalCommands';
import {InputMonitoringCTAModal} from '@app/features/voice/components/modals/InputMonitoringCTAModal';
import type {NativePermissionResult} from '@app/features/voice/utils/NativePermissions';

const INPUT_MONITORING_PERMISSION_MODAL_KEY = 'input-monitoring-permission';

export function openInputMonitoringPermissionModal(options?: {
	onComplete?: (result: NativePermissionResult) => void;
}): void {
	pushWithKey(
		modal(() => <InputMonitoringCTAModal onComplete={options?.onComplete} />),
		INPUT_MONITORING_PERMISSION_MODAL_KEY,
	);
}
